import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { App } from './components/app/app';
import { NotFound } from './components/not-found';
import { Error } from './components/error';
import { Home } from './components/home';
import { Unsubscribe } from './components/unsubscribe';

export function Router() {
  return (
    <App>
      <Route path="/not-found" component={NotFound}/>
      <Switch>
        <Route exact={true} path="/" component={Home}/>
        <Route exact={true} path="/unsubscribe" component={Unsubscribe}/>
        <Route path="/error" component={Error}/>
        <Redirect to="/not-found"/>
      </Switch>
    </App>
  );
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/routes.tsx